import useAppSelector from './useAppSelector';

const useAppUserPermissions = (): string[] => {
  return useAppSelector((state) => state.userPermissions.permissions) || [];
};

export default useAppUserPermissions;
